module.exports = __webpack_public_path__ + "img/favicon.38ab0c1d.svg";